import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = () =>
{
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated())
  {
    return true;
  }

  const preferredSlug = authService.getPreferredCompanySlug();

  if (preferredSlug)
  {
    return router.createUrlTree(['/', preferredSlug, 'login']);
  }

  return router.createUrlTree(['/login']);
};
